module.exports = __webpack_public_path__ + "img/mmp.b4b4cbc3.jpg";